import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryPreview() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-4">
            内容分类
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            探索赤裸特工的世界
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            从剧情到幕后，从演员到观剧指南，你想了解的一切都在这里
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex items-start gap-4 bg-background-100 rounded-lg p-5 md:p-6 border border-background-200 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 no-underline"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                <i className={`${category.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors duration-200">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-2">
                  {category.description}
                </p>
                <span className="text-xs text-foreground-500">
                  {category.articleCount} 篇文章
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}